<template>
  <div>    
    <v-layout row>
      <v-flex xs12 md6>
        <v-layout row>
          <v-flex xs8>
            <v-text-field dense flat
              v-model="available.term"
              append-icon="search"
              label="Search Available"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-btn color="green" dark @click="addChild" small block>
            assign <v-icon small right>arrow_forward</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>        
        <v-data-table dense class="ramping mt-3"
          :headers="available.headers"
          :items="available.items"
          :search="available.term"
          :loading="available.loading"
          :sort-by="['tipe', 'name']"
          :sort-desc="[false, false]"
          loading-text="Loading... Please wait"
          show-select
          v-model="available.selected"            
          item-key="name"
          :items-per-page="15"     
          :mobile-breakpoint="0"         
        > 
          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
          </template>            
        </v-data-table>
      </v-flex>      
      <v-flex xs12 md6>
        <v-layout row>
          <v-flex xs4>
            <v-btn color="orange" dark @click="removeChild" small block>
              <v-icon left small>arrow_back</v-icon> revoke 
            </v-btn>
          </v-flex>
          <v-flex xs8>
            <v-text-field dense flat
              v-model="assigned.term"
              append-icon="search"
              label="Search Assigned"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>          
        <v-data-table dense class="ramping mt-3"
          :headers="assigned.headers"
          :items="assigned.items"
          :search="assigned.term"
          :loading="assigned.loading"
          :sort-by="['tipe', 'name']"
          :sort-desc="[false, false]"
          loading-text="Loading... Please wait"
          show-select
          v-model="assigned.selected"            
          item-key="name"
          :items-per-page="15"
          :mobile-breakpoint="0"  
        > 
          <template v-slot:item.data-table-select="{ isSelected, select }">
            <v-simple-checkbox color="green" :value="isSelected" @input="select($event)"></v-simple-checkbox>
          </template>            
        </v-data-table>
      </v-flex>      
    </v-layout>    
  </div>  
</template>

<script>
import { Ripple } from 'vuetify/lib/directives'
import { debounce } from 'lodash'
import Model from '@/app/models/Admin'
const  model = new Model()


export default {  
  directives : {Ripple},
  data : () => ({    
    perPage:'10',
    perPageOptions: ['10', '20', '50', '-1'],
    available : {      
      items : [], checkedAll:false, selected : [],
      loading : false, term : null,
      headers : [{ text: 'Tp', value: 'tipe' },{ text: 'Name', value: 'name' }],
    },
    assigned : {
      items : [], checkedAll:false, selected : [],
      loading : false, term : null,
      headers : [{ text: 'Tp', value: 'tipe' },{ text: 'Name', value: 'name' }],
    },
    term : null,
    items: [],     
    page : 0,      
    totalPages: 0,      
    loading: false,
    status: {1:'active',0:'inactive'},    
  }),
  computed: {       
    filterAvailable(){
      if (!this.available.term || this.available.term.length < 1) {       
        return this.isChecked(this.available.items, this.available.checkedAll)
      }
      return this.isChecked(this.available.items.filter(item => {
        const textOne    = item.name.toLowerCase()
        const searchText = this.available.term.toLowerCase()
        return textOne.indexOf(searchText) > -1; 
      }), this.available.checkedAll)      
    },
    filterAssigned(){
      if (!this.assigned.term || this.assigned.term.length < 1) {
        return this.isChecked(this.assigned.items, this.assigned.checkedAll)
      }
      return this.isChecked(this.assigned.items.filter(item => {
        const textOne    = item.name.toLowerCase()
        const searchText = this.assigned.term.toLowerCase()
        //return item.name.toLowerCase().startsWith(this.available.term.toLowerCase())
        return textOne.indexOf(searchText) > -1; 
      }), this.assigned.checkedAll)           
    },
  },
  watch: {
    '$route.query.id'() {
        this.init();
    }
  },
  mounted () {
    this.init()
  },
  methods: {    

    searchAvailable: debounce(function (term) {
      this.available.term = term;                  
    }, 800),

    searchAssigned : debounce(function (term) {
      this.assigned.term = term;            
    }, 800),

    isChecked(result, status){
      result.forEach(item=>{item.checked = status ? true:false});
      return result;
    },

    init () {
      this.available.loading = true; this.assigned.loading = true;             
      model.role({id:this.$route.query.id}).then(response => {                                        
        this.readItems(response)
        this.available.loading = false
        this.assigned.loading  = false
      })
    },

    readItems (response){
      this.available.items   = []; this.assigned.items = [];  
      
      if(response.available){
        for(var key in response.available) {
          this.available.items.push({checked:false, name:key, tipe:response.available[key]});
        }
        /*response.available.forEach(item=>{          
          this.available.items.push({checked:false, name:key, tipe:String(item.type)});            
        });*/          
      } 
      if(response.assigned){
        for(var key in response.assigned) {
          this.assigned.items.push({checked:false, name:key, tipe:response.assigned[key]});
        }        
      }
    },

    selectAvailable (data) {
      const idx = this.available.items.findIndex(u => u.name === data.name)
      this.available.items[idx].checked = !this.available.items[idx].checked           
    },

    selectAssigned (data) {
      const idx = this.assigned.items.findIndex(u => u.name === data.name)
      this.assigned.items[idx].checked = !this.assigned.items[idx].checked
    },

    addChild(){
      let arr = []; this.available.selected.forEach(item=>{arr.push(item.name)})
      this.available.loading = true;
      model.roleAssign({items:arr},{id:this.$route.query.id}).then(res=>{
        this.available.loading = false; this.readItems(res)
      })
    },

    removeChild(){
      let arr = []; this.assigned.selected.forEach(item=>{arr.push(item.name)})
      this.assigned.loading = true;
      model.roleRevoke({items:arr},{id:this.$route.query.id}).then(res=>{
        this.assigned.loading = false; this.readItems(res)
      })
    },

    removeRole(id){
      this.$swal({title: 'Are you sure?', text: "You won't be able to revert this!",
        showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
      }).then((result) => {                 
        if (result.value) {                    
          model.deleteRole({id:id}).then(()=>{          
              this.$router.replace({name:'admin/rbac'})
              
          })
        }
      });
    },
  },  
}
</script>
<style>
.ramping td, .ramping th {
    padding: 0 5px;
}
</style>